import { Directive } from '@angular/core';
import { combineLatest, filter, map } from 'rxjs';
import { TranslatableComponent } from '../core/i18n/TranslatableComponent';
import { LoginStatus } from '../core/interceptors/auth.interceptor';
import { AuthActions } from '../core/state/auth/auth.actions';
import { ToastActions } from '../core/state/toast/toast.actions';

@Directive()
export abstract class LoginPageComponent extends TranslatableComponent {
  constructor() {
    super();
    this.store.dispatch(AuthActions.resetAuthStateAndStorage());
    this.showSessionExpiredMessageIfRouteHasErrorParams();
  }

  private showSessionExpiredMessageIfRouteHasErrorParams() {
    combineLatest([this.route.queryParams, this.translationsLoaded$])
      .pipe(
        filter(([queryParams, translations]) => queryParams?.error && Boolean(translations)),
        map(([{ error }, translations]) => ({ error, translations })),
        this.takeUntilDestroyed(),
      )
      .subscribe(({ error, translations }) => {
        if (error === LoginStatus.UnAuthorized) {
          this.store.dispatch(
            ToastActions.showErrorMessage({
              summary: translations.expiredSessionTitle,
              detail: translations.expiredSessionDescription,
            }),
          );
        }

        if (error === LoginStatus.UnAuthorizedInactive) {
          this.store.dispatch(
            ToastActions.showErrorMessage({
              summary: translations.inactiveUserTitle,
              detail: translations.inactiveUserDescription,
            }),
          );
        }

        if (error === LoginStatus.FailedToEndLogin) {
          this.store.dispatch(
            ToastActions.showErrorMessage({
              summary: translations.failedToEndLoginTitle,
              detail: translations.failedToEndLoginDescription,
            }),
          );
        }
      });
  }
}
